import React, { useState, useEffect } from 'react';
import { makeStyles, Button } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';
import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';
import PlayArrowRoundedIcon from '@material-ui/icons/PlayArrowRounded';
import PauseRoundedIcon from '@material-ui/icons/PauseRounded';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Popover from '@material-ui/core/Popover';
import ChangeStatePopoverContent from './ChangeStatePopoverContent';
import { productionOrderStates as orderState } from '../../Config/productionOrderStates'
import { useTranslation } from 'react-i18next';
import EditOrderComponent from './EditOrderComponent';
import CreateOrderComponent from './CreateOrderComponent';


export default function EditCreateOrderDrawer(props) {
    const classes = useStyles();

    const [anchorEl, setAnchorEl] = useState(null);
    const [state, setState] = useState(null);
    const [start, setStart] = useState(null)
    const [end, setEnd] = useState(null)
    const [orderInfo, setOrderInfo] = useState([]);
    const [elapsed, setElapsed] = useState(null)
    const [timer, setTimer] = useState(null)
    const [create, setCreate] = useState(false)
    const [changedState,setChangedState] = useState(false)

    const { t } = useTranslation();

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    useEffect(() => {
        let mounted = true
        let rows = [];
        clearInterval(timer)
        setTimer(null)
        if (mounted && !changedState) {
            if (props.productionOrder) {
                if (state !== props.productionOrder.state) {                   
                    setState(props.productionOrder.state)
                }
                if (end !== props.productionOrder.end) {
                    setEnd(props.productionOrder.end)
                }
                if (start !== props.productionOrder.start) {
                    setStart(props.productionOrder.start)
                }

                rows = [createData('Article', props.articles.find(x => x.id === props.productionOrder.article).name),
                createData('Pieces', props.productionOrder.pieces),
                createData('Line', props.productionOrder.workstation)]
                setOrderInfo(rows)
                setCreate(false)

                let elapsedTimer = setInterval(() => setElapsedTime(), 1000);
                setTimer(elapsedTimer)
            }
            else {
                setCreate(true)
                setStart(props.start)
                setEnd(props.end)
                setState(orderState.PLANNED)
            }
        }

        return function cleanup() {
            mounted = false
        }
    }, [props.productionOrder, state]);

    function setElapsedTime() {
        var diff = (parseInt(parseInt(new Date() - new Date(start)) / (1000 * 60 * 60 * 24))) * (1000 * 60 * 60 * 24)
        var time = new Date() - new Date(start) - diff
        console.log(msToTime(time))
        setElapsed(msToTime(time))
    }

    function saveOrder() {
        clearInterval(timer)
        setTimer(null)
        props.saveOrder(props.productionOrder.id, state, start, end)
    }

    function msToTime(s) {

        // Pad to 2 or 3 digits, default is 2
        function pad(n, z) {
            z = z || 2;
            return ('00' + n).slice(-z);
        }

        var ms = s % 1000;
        s = (s - ms) / 1000;
        var secs = s % 60;
        s = (s - secs) / 60;
        var mins = s % 60;
        s = (s - mins) / 60
        var hrs = s % 24;
        s = (s - hrs) / 24
        var days = s;

        return pad(days) + ':' + pad(hrs) + ':' + pad(mins) + ':' + pad(secs);
    }

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    function handleFromDateChange(date) {
        if(!create){
            setStart(date.target.value)
        }
        else{
            props.setStart(date.target.value)
        }
    }

    function handleTillDateChange(date) {
        if(!create){
            setEnd(date.target.value)
        }
        else{
            props.setEnd(date.target.value)
        }
    }

    function changeState(state) {
        setChangedState(true)
        setState(state)
        setAnchorEl(null)
    }

    function createData(name, info) {
        return { name, info };
    }

    return <Drawer variant="temporary" className={classes.drawer} anchor='right' open={props.drawerOpen} classes={{ paper: clsx({ [classes.drawerOpen]: props.drawerOpen, [classes.drawerClose]: !props.drawerOpen, }), }} onClose={() => props.openDrawer(false)} transitionDuration={500}>
        <div className={classes.drawerBody}>
            <div className={classes.header}>
                <div className={classes.title}>
                    {props.productionOrder ? "Edit order" : "Create order"}</div>
                <div className={classes.close}>
                    <Button className={classes.closeButton} onClick={() => props.openDrawer(false)}><CloseIcon></CloseIcon></Button>
                </div>
            </div>
            <div className={classes.body}>
                {state ? <React.Fragment>
                    {props.productionOrder ? <React.Fragment><div className={classes.orderno}>
                        Ordern°
                    </div>
                        <div className={classes.article}>
                            {props.productionOrder.ordernumber}
                        </div></React.Fragment> :
                        <React.Fragment></React.Fragment>}
                    <div>
                        <Button className={classes.stateButton} aria-describedby={id} onClick={handleClick}>
                            <div className={classes.stateIcon}>
                                {state === orderState.RUNNING ?
                                    <PlayArrowRoundedIcon className={classes.play}></PlayArrowRoundedIcon> :
                                    state === orderState.PAUSED ?
                                        <PauseRoundedIcon className={classes.pause} ></PauseRoundedIcon> :
                                        state === orderState.STOPPED ?
                                            <div className={classes.stop}></div> :
                                            state === orderState.CANCELLED ?
                                                <div className={classes.cancel}><svg xmlns="http://www.w3.org/2000/svg" version="1.1" id="Layer_1" x="0px" y="0px" width="20px" height="20px" viewBox="0 0 121.31 122.876" enableBackground="new 0 0 121.31 122.876"><g><path fillRule="evenodd" clipRule="evenodd" d="M90.914,5.296c6.927-7.034,18.188-7.065,25.154-0.068 c6.961,6.995,6.991,18.369,0.068,25.397L85.743,61.452l30.425,30.855c6.866,6.978,6.773,18.28-0.208,25.247 c-6.983,6.964-18.21,6.946-25.074-0.031L60.669,86.881L30.395,117.58c-6.927,7.034-18.188,7.065-25.154,0.068 c-6.961-6.995-6.992-18.369-0.068-25.397l30.393-30.827L5.142,30.568c-6.867-6.978-6.773-18.28,0.208-25.247 c6.983-6.963,18.21-6.946,25.074,0.031l30.217,30.643L90.914,5.296L90.914,5.296z" /></g></svg></div> :
                                                state === orderState.PLANNED ?
                                                    <img className={classes.planned} alt="planned" src={process.env.PUBLIC_URL + '/img/planned.svg'}></img> :
                                                    state === orderState.DONE ?
                                                        <img className={classes.done} alt="done" src={process.env.PUBLIC_URL + '/img/done.svg'}></img> :
                                                        <React.Fragment></React.Fragment>
                                }
                            </div>
                            <div className={classes.stateContainer}>
                                <div className={classes.state}>
                                    {state}
                                </div>
                                <div className={classes.elapsed}>
                                    {state === orderState.RUNNING ? elapsed : <React.Fragment></React.Fragment>}
                                </div>
                            </div >
                            <div className={classes.expand}>
                                <ExpandMoreIcon className={classes.arrowIcon}></ExpandMoreIcon>
                            </div>
                        </Button>
                        <Popover
                            id={id}
                            open={open}
                            anchorEl={anchorEl}
                            onClose={handleClose}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                            }}
                        >
                            <ChangeStatePopoverContent state={state} changeState={changeState} popoverWidth={"20vw"}></ChangeStatePopoverContent>
                        </Popover>
                    </div>
                    <div className={classes.editOrCreate}>
                        {!create ? <EditOrderComponent orderInfo={orderInfo} start={start} end={end} saveOrder={saveOrder} handleFromDateChange={handleFromDateChange} handleTillDateChange={handleTillDateChange}></EditOrderComponent> :
                            <CreateOrderComponent start={props.start} end={props.end} selectedWorkstation={props.selectedWorkstation} state = {state} articles={props.articles} createOrder={props.createOrder} handleFromDateChange={handleFromDateChange} handleTillDateChange={handleTillDateChange} {...props}></CreateOrderComponent>}
                    </div>
                </React.Fragment> : <React.Fragment></React.Fragment>}
            </div>
        </div>
    </Drawer>
}

const useStyles = makeStyles(() => ({
    drawerBody: {
        width: "100%",
        height: "100%",
        background: 'linear-gradient(#EFEFEF,#FFFFFF)',
        padding: "20px",
        paddingRight: "5px",
        paddingTop: "10px",
        boxSizing: "border-box"
    },
    closeButton: {
        float: 'right',
        "&:hover": {
            background: "#EFEFEF"
        },
        paddingRight: "0px !important",
        width: "25px !important",
        height: "25px !important",
        minWidth: "0px !important",
    },
    drawerOpen: {
        width: "30%",
    },
    drawerClose: {
        width: 0
    },
    close: {
        width: "20%",
        float: 'left',
    },
    title: {
        float: 'left',
        width: "80%",
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#000000",
        marginTop: "10px",
    },
    header: {
        width: "100%",
        height: "50px",
    },
    form: {
        width: "100%",
        height: "100%"
    },
    body: {
        width: "100%",
        height: "95%"
    },
    orderno: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#8D8D8D",
        display: "block",
        textAlign: "left",
        marginTop: "20px"
    },
    article: {
        fontSize: "22px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#020100",
        display: "block",
        textAlign: "left"
    },
    stateButton: {
        backgroundColor: "white",
        width: "100%",
        border: "1px solid #DEDEDE",
        marginTop: "20px",
        "&:hover": {
            background: "white"
        },
    },
    arrowIcon: {
        fill: "#020100",
        width: "20px",
        height: "20px"
    },
    stateIcon: {
        float: "left",
        width: "10%",
        marginRight: "20px"
    },
    stateContainer: {
        float: "left",
        width: "80%"
    },
    expand: {
        float: "right",
        width: "10%"
    },
    play: {
        color: "#5CC958",
        height: "40px",
        width: "40px"
    },
    stop: {
        height: "20px",
        width: "20px",
        backgroundColor: "#D84949",
        borderRadius: "3px",
        margin: "10px",
        marginTop: "8px"
    },
    pause: {
        height: "35px",
        width: "35px",
        color: "#F59127",
        marginLeft: "5px"
    },
    cancel: {
        margin: "10px",
        marginTop: "8px",
        marginLeft: "12px"
    },
    planned: {
        marginRight: "10px",
        marginLeft: "5px"
    },
    done: {
        marginRight: "10px",
        marginLeft: "5px"
    },
    elapsed: {
        fontSize: "10px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#8D8D8D",
        textAlign: "left"
    },
    state: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
        textAlign: "left"
    },
    changeState: {
        backgroundColor: "white",
        width: "20vw"
    },
}));